import React, { FC, memo } from 'react';

import InputSearch, { InputSize } from '@zvuk-b2b/react-uikit/ui/InputSearch';
import IconSettingsSlider from '@zvuk-b2b/react-uikit/ui/icons/Settings copy';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import type { AddressSearchRowProps } from './types';

import styles from '../index.module.scss';

const AddressSearchRow: FC<AddressSearchRowProps> = ({
  isTagFilterOpen,
  hasActiveTags,
  search,
  filterButtonRef,
  onAddressSearchChange,
  onTagFilterToggle,
}) => (
  <div className={styles.searchRow}>
    <InputSearch
      elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SEARCH}
      value={search}
      placeholder={TEXTS.AUDIO_REPORT_ADDRESSES_SEARCH_PLACEHOLDER}
      size={InputSize.SMALL}
      containerClassName={styles.search}
      inputClassName={styles.searchInput}
      onChange={onAddressSearchChange}
    />

    <button
      ref={filterButtonRef}
      type="button"
      className={styles.filterButton}
      aria-expanded={isTagFilterOpen}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_FILTER_BUTTON}
      onClick={onTagFilterToggle}>
      <div className={styles.filterButtonIconWrapper}>
        {hasActiveTags && <div className={styles.filterButtonBadge} />}
        <IconSettingsSlider />
      </div>
    </button>
  </div>
);

export default memo(AddressSearchRow);
